import { Home } from 'lucide-react';
import React from 'react';
import { XStack, Image } from 'tamagui';

import { TemperatureLabel } from './TemperatureLabel';
import { cloudyIcon, overcastIcon } from '../../../assets';
import { useWeather } from '../../../hooks';
import { useThermostatData } from '../../../hooks/air/useThermostatData';

export const TemperatureOverview: React.FC = () => {
  const { todayTemperature } = useThermostatData();
  const { outsideTemperature, weatherCondition } = useWeather();
  const weather = weatherCondition || 'Overcast';
  const weatherIcon = weather.toLowerCase() === 'cloudy' ? cloudyIcon : overcastIcon;

  const tempString = `${todayTemperature ?? '--'}°F`;

  return (
    <XStack
      width="100%"
      height="100%"
      justifyContent="space-between"
      flex={1}
      alignItems="stretch"
      gap="$14">
      {/* In-Home Section */}
      <TemperatureLabel icon={<Home size={70} />} temperature={tempString} location="In-Home" />

      {/* Outdoor Section */}
      <TemperatureLabel
        icon={
          <Image
            source={{ width: 70, height: 70, uri: weatherIcon }}
            alt="Weather Icon"
            width={70}
            height={70}
          />
        }
        temperature={outsideTemperature}
        location="Outdoor"
      />
    </XStack>
  );
};
